export const dmv = {
  agencyCode: '608',
  name: 'Texas Department of Motor Vehicles',
  shortName: 'DMV',
  slug: 'dmv',
};
